import { types as api } from '@mesa-labs/mesa-api';
import { ExternalVendorApi } from '@mesa-labs/mesa-api/dist/apis/externalVendor';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders, useApi } from './api';

export const dataReconciliationApi = createApi({
  reducerPath: 'dataReconciliationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.api.externalVendorUrl,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    getRowCountReconciliation: build.query<api.RowCountReconciliationResponse, api.Partners>({
      async queryFn(partnerId) {
        const externalVendorApi = useApi((options) => new ExternalVendorApi(CONFIG.api.externalVendorUrl, options));
        const data = await externalVendorApi.getRowCountReconciliation(partnerId);
        return { data };
      },
    }),
  }),
});

export const { useLazyGetRowCountReconciliationQuery } = dataReconciliationApi;
